import AppSaga from "@Store/App/saga";
import AppUserSaga from "@Store/AppUser/saga";
import InvitesSaga from "@Store/Invites/saga";
import MasterDataSaga from "@Store/MasterData/saga";
import MatrixSaga from "@Store/Matrix/saga";
import NotificationSaga from "@Store/Notification/saga";
import OrganizationsSaga from "@Store/Organizations/saga";
import AppsSaga from "@Store/Apps/saga";
import TeamsSaga from "@Store/Team/saga";
import UsersSaga from "@Store/Users/saga";
import UserUpdateRequestsSaga from "@Store/UserUpdateRequests/saga";
import { spawn } from "redux-saga/effects";

export default function* () {
  yield spawn(NotificationSaga);
  yield spawn(AppSaga);
  yield spawn(AppUserSaga);
  yield spawn(OrganizationsSaga);
  yield spawn(AppsSaga);
  yield spawn(MasterDataSaga);
  yield spawn(MatrixSaga);
  yield spawn(UsersSaga);
  yield spawn(InvitesSaga);
  yield spawn(TeamsSaga);
  yield spawn(UserUpdateRequestsSaga);
}
